export const categories = [
  {
    slug: 'shengli-jiegou',
    name: '生理结构',
    description: '了解女性阴道的解剖结构和生理功能，认识自己的身体',
    icon: 'ri-psychotherapy-line',
    color: 'primary',
  },
  {
    slug: 'richang-huli',
    name: '日常护理',
    description: '科学护理私密部位，避免常见的护理误区',
    icon: 'ri-heart-pulse-line',
    color: 'accent',
  },
  {
    slug: 'changjian-wenti',
    name: '常见问题',
    description: '阴道炎、分泌物异常等常见困扰的科学解答',
    icon: 'ri-stethoscope-line',
    color: 'secondary',
  },
  {
    slug: 'jiuyi-zhinan',
    name: '就医指南',
    description: '何时就医、如何与医生沟通、检查项目解读',
    icon: 'ri-hospital-line',
    color: 'primary',
  },
];